import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import radioIcon from 'components/asset/RadioColumn.svg';

export const useColumnDefsForApprovalList = () => {
  const { t } = useTranslation();
  const defaultColDef = useMemo((): ColDef => {
    return {
      sortable: false,
      resizable: true,
      cellStyle: { textAlign: 'left' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  const colDefs = useMemo((): any[] => {
    return [
      {
        headerName: 'radio',
        headerComponentParams: {
          template: `<img src=${radioIcon} alt=''/>`,
        },
        width: '28px !important',
        height: '24px !important',
        padding: '2px 6px',
        resizable: false,
        headerCheckboxSelection: true,
        showDisabledCheckboxes: true,
        checkboxSelection: true,
        flex: 0,
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          width: '28px !important',
          height: '24px',
        },
      },
      {
        headerName: t('컬럼1코드', '개설은행'),
        field: 'column1',
        tooltipField: 'column1',
        width: '200px',
        minWidth: 200,
      },
      {
        headerName: t('컬럼2코드', '은행'),
        field: 'column2',
        tooltipField: 'column2',
        flex: 1,
        minWidth: 730,
      },
    ];
  }, []);

  const handleAprvDetailBtn = (data) => {
    console.log('화면 연결이 필요합니다.');
  };

  return { defaultColDef, colDefs };
};
